import React, {Component} from "react";
import {
    Platform,
    View,
    ScrollView,
    TouchableOpacity,
    KeyboardAvoidingView,
    ActivityIndicator,
} from "react-native";


import {moderateScale} from '../../../../tools/Scaling';


import HMActionBar from "../../../../customviews/HMActionBar";


import i18n from '../../../../I18n/i18n.js';

const SLIDER_1_FIRST_ITEM = 1;

import * as NavigationService from "../../../../redux/NavigationService";
import DialogLoadingCustomize from "../../../../customviews/DialogLoadingCustomize";
import {Tools} from "../../../../tools/Tools";
import HMTextView from "../../../../customviews/HMTextView";
import Colors from "../../../../tools/Colors";
import HMImageView from "../../../../customviews/HMImageView";
import PathFile from "../../../../assets/PathFile";
import {typeExport} from "../../../../redux/store/type";

import HMLoading from "../../../../customviews/HMLoading";

import DialogConnectionCustomize from "../../../../customviews/DialogConnectionCustomize";
import store from "../../../../redux/store";
import {AsyngStorageClass} from "../../../../tools/AsyngStorageClass";
import {DialogUpdateAppCustomize} from "../../../../customviews/dialogUpdateApp/DialogUpdateAppCustomize";
import HMAlert from "../../../../customviews/HMAlert";

let container = null;
let countTest = 0;


import {callWebservice as callWebserviceSplash} from "../../splash/action/ActionSplashGetAllData";
import HMIcon from "../../../../customviews/HMIcon";
import connect from "react-redux/es/connect/connect";


class ApplyParentScreen extends Component {


    constructor(props) {
        super(props);
        container = this;
        let viewportWidth = 1;
        let viewportHeight = 1;
        if (Platform.OS === "web") {
            viewportWidth = document.documentElement.clientWidth;
            viewportHeight = document.documentElement.clientHeight;


        }
        // switch (Platform.OS) {
        //
        //     case "android":
        //         firebase = require("react-native-firebase")
        //
        //         break;
        //     default:
        //
        // }
        // if (Platform.OS === "android") {
        //      firebase = require("react-native-firebase")
        //     // alert(firebase)
        //
        // }
        this.state = {
            columnCount: 2,
            slider1ActiveSlide: SLIDER_1_FIRST_ITEM,
            isLoading: false,
            alaki: false,
            viewportWidth: viewportWidth,
            viewportHeight: viewportHeight,
            itemWidth: Platform.OS === "web" ? (viewportWidth > 600 ? 480 : viewportWidth) : typeExport._WIDTH,
        };
        this.props.navigation.addListener('focus', () => {


                this.setState({
                    alaki: !this.state.alaki,
                })
                container = this;
            }
        )
        this.props.navigation.addListener('blur', () => {
        })

        let {resultsShahrdar} = store.getState().reducerSplashGetAllData;

    }

    async getDataServerSplash() {
        let dataSplash = this.props.DataSplashScreen;
        if (dataSplash.TypeLogin == 2 || dataSplash.TypeLogin == 1 || dataSplash.TypeLogin == null) {

            let paramss = {
                "token": dataSplash.token,
                "id": 1,
                "lang": i18n.locale,
                "imei": 0,
                'token_mahale': dataSplash.tokenMahaleh,
                //  'tenant_id': store.getState().reducerSplashGetAllData?.City?.tenant_id,

                "token_fb": dataSplash.token_fb,
            };
            paramss = Tools.addAllParams(paramss);

            if (dataSplash.Connection) {

                if (global.GoOfflineToMain || !(this.props.DataSplashScreen.results))

                    if ((global._loadDataCount && global._loadDataCount > 0) || (global.GoOfflineToMain || !(dataSplash.TypeLogin == 2 ? dataSplash.resultsShahrdar : dataSplash.results))) {
                        if (dataSplash.TypeLogin == 2)
                            store.dispatch(callWebserviceSplash(typeExport._baseUrlSainaShahrdar, paramss, typeExport.TypeGetAllDataShardar, typeExport._POST, dataSplash.token, dataSplash.token_fb, null, "MainScreen"))
                        else {
                            store.dispatch(callWebserviceSplash(typeExport.urlGetAllDataSaina, paramss, typeExport.TypeGetAllDataSaina, typeExport._GET, dataSplash.token, dataSplash.token_fb, null, "MainScreen"))

                        }
                        //  this.props.callService(typeExport._baseUrlSainaShahrdar, paramss, typeExport.TypeGetAllDataShardar, typeExport._POST, token, token_fb, imageBack);

                    }
                    else
                        global._loadDataCount = global._loadDataCount ? global._loadDataCount + 1 : 1;


                await AsyngStorageClass.setAsyng("splash" + global.IdCity, dataSplash.results);

                if (dataSplash.TypeLogin == 2)
                    await AsyngStorageClass.setAsyng("splashShahrdar" + global.IdCity, dataSplash.resultsShahrdar);
                else
                    await AsyngStorageClass.setAsyng("splashSaina" + global.IdCity, dataSplash.resultsSaina);

            }
            else {
                if (dataSplash.TypeLogin == 2)
                    store.dispatch(callWebserviceSplash(typeExport._baseUrlSainaShahrdar, paramss, typeExport.TypeGetAllDataShardar, typeExport._POST, dataSplash.token, dataSplash.token_fb, null, "MainScreen"))
                else {
                    store.dispatch(callWebserviceSplash(typeExport.urlGetAllDataSaina, paramss, typeExport.TypeGetAllDataSaina, typeExport._GET, dataSplash.token, dataSplash.token_fb, null, "MainScreen"))

                }
            }
        }

    }

    componentDidMount() {
        // if (this.props.DataSplashScreen.TypeLogin == 2 && (typeExport._NameApp == "MahalemaArak"))
        //     this.getDataServerSplash();
        // global.ref_toast.current.show({
        //     text1: 'Hello',
        //     text2: 'This is some something 👋'
        // })
        // Toast.show({
        //     text1: 'Hello',
        //     text2: 'This is some something 👋'
        // });

        if (Platform.OS === "web")
            window.addEventListener("resize", function (event) {
                const IS_IOS = Platform.OS === 'ios';
                let viewportWidth = document.documentElement.clientWidth;
                let viewportHeight = document.documentElement.clientHeight;


                container.setState({
                        viewportWidth: viewportWidth,
                        viewportHeight: viewportHeight,
                        itemWidth: viewportWidth > 600 ? 480 : viewportWidth,
                        columnCount: viewportWidth > 600 ? 4 : 2,
                    },
                )


            })

        this.unsubscribeFromNotificationListener = Tools.receiveonOnNotification(this.changeMenu)

    }

    changeMenu() {
        container.setState({alaki: !container.state.alaki})
    }

    getData() {
        let {mobile, password} = this.state;

        let paramss = {
            "_operation": typeExport._Shahrdar,

            "mode": typeExport._GetCalendar,
            "lang": i18n.locale,

            //    "username": mobile,
            //  "password": password,
            //
            // "username": Tools.persianToEnglish(mobile),
            // "password": Tools.persianToEnglish(password),
            // "token_fb": this.props.DataSplashScreen.token_fb,
        };


    }

    componentWillUnmount() {

        if (Platform.OS === 'android') {
            this.unsubscribeFromNotificationListener();
        }
    }

    render() {
        let {viewportWidth, viewportHeight} = this.state;
        let list = this.props.route.params ? this.props.route.params.list : null;
        let request_server = this.props.route.params ? this.props.route.params.request_server : null;
        // let item = this.props.route.params ? this.props.route.params.item : null;
        let _params = this.props.route.params;
        let item = _params ? JSON.parse(_params.item) : null;
        let {resultsShahrdar} = store.getState().reducerSplashGetAllData;
        let type = this.props.route.params ? this.props.route.params.type : null;

        let checkLogin = (store.getState().reducerSplashGetAllData.TypeLogin == 2 || typeExport._NameApp == "MahalemaArak");

        let dataList = [{name: "آب", id: 1, svg: "https://hormozgan.shahrban.org/images/svg/ab_logo.svg"}]
        return (
            <View style={{position: 'relative', flex: 1}}>


                <View style={{position: 'absolute', top: 0, bottom: 0, left: 0, right: 0}}>
                    <KeyboardAvoidingView style={{flex: 1,}} behavior={"padding"}
                                          enabled={Platform.OS === "ios"}>
                        <HMActionBar
                            //  menu={!checkLogin}
                            menu={typeExport._NameApp != "MahalemaArak"}
                            // menu
                            back={typeExport._NameApp != "MahalemaArak"}
                            //  exit={checkLogin && !type}
                            exit={typeExport._NameApp == "MahalemaArak"}
                            funcExit={checkLogin ? () => {

                                HMAlert(
                                    i18n.t('constant.message'),
                                    "آیا می خواهید از حساب کاربری خود خارج شوید؟",
                                    [
                                        // {text: 'Ask me later', onPress: () => {}},
                                        // {text: 'Cancel', onPress: () => {}, style: 'cancel'},
                                        {
                                            text: i18n.t('constant.ok'), onPress: () => {
                                                AsyngStorageClass.removeToken(typeExport._Shahrdar);
                                                NavigationService.resetTo('LoginStackScreen');

                                            }
                                        },
                                    ],
                                    {cancelable: true}
                                )


                                // Tools.remove()
                                // NavigationService.resetTo("SplashScreen")
                            } : null}
                            props={this.props} statusBarTransparent
                            //  text={i18n.t('Apply.title')}
                            // text={item ? (item.name ? item.name : (item.title ? item.title : '')) : checkLogin && this.props.DataSplashScreen.user ? this.props.DataSplashScreen.user.name + " " + this.props.DataSplashScreen.user.family : null}
                            text={item ? (item.name ? item.name : (item.title ? item.title : '')) : checkLogin && this.props.DataSplashScreen.user ? i18n.t('appName') : null}
                            //  text={i18n.t('constant.Information')}

                            headerVisibility more_menu
                            onBackPress={() => this.props.navigation.pop()}
                            // funcExit={checkLogin ? () => {
                            //
                            //     HMAlert(
                            //         i18n.t('constant.message'),
                            //         "آیا می خواهید از حساب کاربری خود خارج شوید؟",
                            //         [
                            //             // {text: 'Ask me later', onPress: () => {}},
                            //             // {text: 'Cancel', onPress: () => {}, style: 'cancel'},
                            //             {
                            //                 text: i18n.t('constant.ok'), onPress: () => {
                            //                     AsyngStorageClass.removeToken(typeExport._Shahrdar);
                            //                 }
                            //             },
                            //         ],
                            //         {cancelable: true}
                            //     )
                            //
                            //
                            //     // Tools.remove()
                            //     // NavigationService.resetTo("SplashScreen")
                            // } : null}
                            styleText={[!checkLogin ? {} : {marginStart: moderateScale(48)}]}

                        />


                        <View style={{flex: 1, alignItems: 'center'}}>

                            {
                                this.props.results == null && this.props.isLoading && request_server ?
                                    <HMLoading/>

                                    :
                                    <ScrollView
                                        style={{
                                            //   backgroundColor:"#dd2dee"
                                        }}>
                                        <View
                                            style={{
                                                //position:'absolute',
                                                flexDirection: "row",
                                                flexWrap: 'wrap',
                                                flex: 1,

                                                flexGrow: 1,
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                marginTop: moderateScale(12)
                                                //  backgroundColor: _main ? "#eee" : Colors.transparent,
                                                //  backgroundColor: "#876a79",
                                            }}>


                                            {
                                                dataList && dataList.length > 0 ?
                                                    dataList.map((item, key) => {
                                                        //  (this.state.data).find((obj) => obj.locale == i18n.locale).list.map((item, key) => {
                                                        return (
                                                            //type=0 => پیوند ,type=1 => اخبار ,type=2 => صفحه ,type=3 => منو ,type=4 => اسلایدر ,type=5 => 137 یار ,type=6 => نقشه ,,type=7 => شکایات ,,type=8 =>  ارامستان ,
                                                            <TouchableOpacity
                                                                key={key + "iii"}
                                                                onPress={() => {

                                                                    NavigationService.navigateParams("ListMyApplyParentScreen", {
                                                                        item: this.props.route.params.item,
                                                                        itemOriginal: this.props.route.params.itemOriginal,
                                                                        data: JSON.stringify(item)
                                                                    })

                                                                }}
                                                                style={{
                                                                    // width: "100%",

                                                                    //  width: '100%',
                                                                    //  flex:1,
                                                                    height: this.state.itemWidth / 2 + moderateScale(10),
                                                                    marginHorizontal: moderateScale(4),
                                                                    marginBottom: moderateScale(4),
                                                                    borderRadius: moderateScale(6),
                                                                    //borderColor: '#d0d8df',
                                                                    borderColor: "#164A70",
                                                                    backgroundColor: Colors.white,
                                                                    borderWidth: moderateScale(1),
                                                                    //  marginVertical: moderateScale(2),
                                                                    // padding: moderateScale(6)
                                                                }}>
                                                                <View style={{
                                                                    flex: .8,
                                                                    width: this.state.itemWidth / 2 - moderateScale(10),
                                                                    alignItems: 'center',
                                                                    justifyContent: 'center'
                                                                }}>

                                                                    <View
                                                                        style={{
                                                                            width: this.state.itemWidth / 5,
                                                                            height: this.state.itemWidth / 5,
                                                                        }}
                                                                    >
                                                                        {
                                                                            item.svg ?

                                                                                <HMIcon

                                                                                    //source={require('../../../../../assets/img/success.png')}
                                                                                    //source={PathFile.image.background}
                                                                                    //svg={PathFile.svg.add}
                                                                                    type={"svg"}
                                                                                    uri={item.svg}
                                                                                    height={this.state.itemWidth / 5}
                                                                                    width={this.state.itemWidth / 5}

                                                                                    name={"add-circle-sharp"} style={{
                                                                                    // fontSize: moderateScale(20),
                                                                                    // color: Colors.blue,
                                                                                    // marginHorizontal: moderateScale(4),
                                                                                    marginRight: moderateScale(4),
                                                                                    marginLeft: moderateScale(4),
                                                                                    //  marginTop: moderateScale(3)
                                                                                }}/>
                                                                                :
                                                                                (item.image_source ?

                                                                                        <HMImageView
                                                                                            // resizeMode={FastImage.resizeMode.contain}
                                                                                            resizeMode={"contain"}
                                                                                            _backgroundColorLoading={Platform.OS === "web" ? Colors.transparent : null}
                                                                                            //  uriComplete={"https://cdnw.elicdn.com/Blog/wp-content/uploads/2018/03/%D8%B9%DA%A9%D8%B3-%D8%A7%D8%B5%D9%84%DB%8C-%D9%85%D8%AA%D9%86-%D9%87%D8%A7-%D8%A8%D8%A7-%D9%84%D9%88%DA%AF%D9%88-25.jpg"}
                                                                                            // uriComplete={item.image}
                                                                                            source_image={item.image_source}
                                                                                            styleText={{marginTop: moderateScale(10)}}
                                                                                            borderRadius={4}/>
                                                                                        :
                                                                                        <HMImageView
                                                                                            // resizeMode={FastImage.resizeMode.contain}
                                                                                            resizeMode={"contain"}
                                                                                            _backgroundColorLoading={Platform.OS === "web" ? Colors.transparent : null}

                                                                                            //  uriComplete={"https://cdnw.elicdn.com/Blog/wp-content/uploads/2018/03/%D8%B9%DA%A9%D8%B3-%D8%A7%D8%B5%D9%84%DB%8C-%D9%85%D8%AA%D9%86-%D9%87%D8%A7-%D8%A8%D8%A7-%D9%84%D9%88%DA%AF%D9%88-25.jpg"}
                                                                                            uriComplete={item.image}
                                                                                            //source_image={item.image}
                                                                                            styleText={{marginTop: moderateScale(10)}}
                                                                                            borderRadius={4}/>
                                                                                )
                                                                        }
                                                                    </View>
                                                                    {
                                                                        item.count ?
                                                                            <View
                                                                                style={{
                                                                                    position: 'absolute',
                                                                                    top: 0,
                                                                                    right: 0,
                                                                                    backgroundColor: Colors.red,
                                                                                    height: moderateScale(30),
                                                                                    width: moderateScale(30),
                                                                                    borderRadius: moderateScale(15),
                                                                                    margin: moderateScale(4),
                                                                                    alignItems: 'center',
                                                                                    justifyContent: 'center'
                                                                                }}>

                                                                                <HMTextView
                                                                                    numberOfLines={1}
                                                                                    type={"bold"}
                                                                                    // text={" اگر در سازمان شما هم افراد مغرور و شخصیت های قوی وجود دارد لازم است بدانید، هنر فرگوسن این بود که به تمام"}
                                                                                    text={item.count}

                                                                                    style={{
                                                                                        fontSize: moderateScale(10),

                                                                                        color: Colors.white,


                                                                                        //  textAlign: "right",
                                                                                    }}/>

                                                                            </View>
                                                                            :
                                                                            null
                                                                    }
                                                                </View>

                                                                <View style={{
                                                                    flex: .2,
                                                                    //backgroundColor: "#f4f4f4",
                                                                    backgroundColor: "#164A70",
                                                                    alignItems: 'center',
                                                                    justifyContent: 'center',
                                                                    borderTopColor: '#d0d8df',
                                                                    borderBottomColor: Colors.transparent,
                                                                    borderRightColor: Colors.transparent,
                                                                    borderLeftColor: Colors.transparent,
                                                                    borderWidth: moderateScale(1),
                                                                }}>
                                                                    <HMTextView
                                                                        numberOfLines={2}
                                                                        type={"bold"}
                                                                        // text={" اگر در سازمان شما هم افراد مغرور و شخصیت های قوی وجود دارد لازم است بدانید، هنر فرگوسن این بود که به تمام"}
                                                                        text={item.name}
                                                                        style={{
                                                                            fontSize: moderateScale(13),

                                                                            color: Colors.white,
                                                                            marginTop: moderateScale(4),
                                                                            //  textAlign: "right",
                                                                        }}/>
                                                                </View>


                                                            </TouchableOpacity>
                                                        ) //if you have a bunch of keys value pair

                                                    })
                                                    :
                                                    null

                                            }
                                        </View>
                                    </ScrollView>

                            }

                            {
                                this.state.isLoading ?
                                    <DialogLoadingCustomize/>
                                    : null
                            }


                            {
                                this.props.NoInternetDialog ?
                                    <DialogConnectionCustomize onPress={() => this.getData()}/> : null
                            }

                            {
                                checkLogin ?
                                    <DialogUpdateAppCustomize/>
                                    :
                                    null
                            }
                        </View>

                    </KeyboardAvoidingView>
                </View>
            </View>
        );
    }


    goScreen(route, item, position) {
        let checkLogin = (store.getState().reducerSplashGetAllData.TypeLogin == 2)

        container.setState({isLoading: false})
        NavigationService.navigateParams(route, {
            position: JSON.stringify(Tools.cloneAsObject(position)),
            //   position: JSON.stringify(position),
            //  position:position,
            typeComponent: checkLogin ? "Operation" : null,
            item: container.props.navigation && container.props.route && container.props.route.params ? container.props.route.params.item : JSON.stringify(item),
            data: JSON.stringify(item),
            type: route
        })
    }

    stateError() {
        container.setState({
            locationEnabled: false,
            isLoading: false,
        }, () => {
        })
    }

}

const mapStateToProps = (state) => {

    return {
        DataSplashScreen: state.reducerSplashGetAllData,
        token: state.reducerSplashGetAllData.token,


    }
}
const mapDispatchToProps = dispatch => {
    return {}
}
export default connect(mapStateToProps, mapDispatchToProps)(ApplyParentScreen);
